import { render } from "./BodyMass.vue?vue&type=template&id=64e67614"
import script from "./BodyMass.vue?vue&type=script&lang=js"
export * from "./BodyMass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__